import {
    TextField,
    Typography } from "../../ui";
import {
  isEmpty
} from "../../../constants/constant";

const BuildTextViewUi = ({ prodName, dialogMsg, setDialogMsg,label,minRows = 4 }) => {

    return (
        <>
            {
                !isEmpty(prodName) && 
                <Typography style={{ whiteSpace: 'pre-wrap', 
                        overflowWrap: 'break-word',fontWeight:"bold", fontSize: '16px' }}>{prodName}</Typography>
            }
            
            <TextField
                id="textReason"
                required
                name="textReason"
                variant="filled"
                size="small"
                defaultValue={dialogMsg}
                label={label}
                rows={minRows}
                maxRows={minRows}
                minRows={minRows}
                multiline
                onChange={(e) => setDialogMsg(e.target.value)}
                style={{ width: "100%" }}
            />
        </>
    );
}
export default BuildTextViewUi;